import React, { FC, SVGProps } from 'react';

type CheckProps = {
  fillColor?: SVGProps<SVGSVGElement>['fill'];
};

export const Check: FC<CheckProps> = ({ fillColor = Styles.color.white }) => (
  <svg
    width="12px"
    height="9px"
    viewBox="0 0 12 9"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Screens" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="TH.MN.3.0-Cart-Flow-1.2" transform="translate(-5.000000, -295.000000)">
        <path
          d="M16.4771466,297.197603 C14.527051,299.142905 12.5802331,301.091444 10.6324933,303.039184 C10.4428447,303.228832 10.2556052,303.420087 10.0635558,303.606523 C9.71065597,303.949816 9.21534255,303.949017 8.86725678,303.602522 C7.7133623,302.451824 6.5602053,301.299568 5.40872808,300.145632 C5.04222605,299.778331 4.90620384,299.340623 5.06623479,298.838897 C5.23107774,298.32357 5.60157644,298.03229 6.13130513,297.960263 C6.55621067,297.902649 6.91470295,298.06589 7.21157553,298.361959 C7.8637447,299.012531 8.50550734,299.673488 9.16406791,300.317668 C9.53776026,300.682551 9.4225306,300.667351 9.76582281,300.32487 C11.4086393,298.686847 13.049817,297.046406 14.6878194,295.402873 C15.022303,295.06759 15.4184062,294.941155 15.8761292,295.025165 C16.4674776,295.133993 16.8819971,295.651728 16.8851928,296.391922 C16.8827921,296.631989 16.7395548,296.936052 16.4770852,297.197731 L16.4771466,297.197603 Z"
          fill={fillColor}
          fillRule="nonzero"
        />
      </g>
    </g>
  </svg>
);
